<div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="30px" fxLayoutGap.lt-md="0px">
    <div fxFlex="60">
        <div class="service-provider-details-container card-height mt-8">
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
                <p class="service-provider-nav">
                    {{ "SERVICE_PROVIDER.SERVICE_PROVIDER" | translate }}
                </p>
                <!-- <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
          fxLayoutGap="20px"
        >
          <div fxLayout="row">
            <mat-slide-toggle
              (change)="changeRepair()"
              [checked]="checked"
              [disabled]="isSlideToggleDisabled() || isOngoingConnectCall"
              labelPosition="before"
            >
              <span class="service-provider-toggle">
                {{ "FOR_REPAIR" | translate }} &nbsp;</span
              >
            </mat-slide-toggle>
          </div>
          <mat-spinner
            [diameter]="18"
            *ngIf="isOngoingConnectCall"
          ></mat-spinner>
        </div> -->
            </div>
            <div>
                <div class="service-provide-info mt-14">
                    <p class="service-provide-header">
                        {{ "SERVICE_PROVIDER.PERSON_NAME" | translate }}
                    </p>
                    <p class="service-provide-des">
                        {{ providerInfo?.name || "" }}
                    </p>
                </div>
                <div fxLayout="row" fxLayoutGap="20px" class="mt-14">
                    <div fxFlex="50" class="service-provide-info">
                        <p class="service-provide-header">UID</p>
                        <p class="service-provide-des">
                            {{ providerInfo?.uid || "" }}
                        </p>
                    </div>
                    <div fxFlex="50" class="service-provide-info">
                        <p class="service-provide-header">{{ "SERVICE_PROVIDER.TRADE" | translate }}</p>
                        <div>
                            <p
                                class="service-provide-des multiline-ellipsis"
                                [matTooltip]="providerInfo?.tradeIds | getTradeName: tradeList"
                            >
                                {{ providerInfo?.tradeIds | getTradeName: tradeList }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="table-separator"></div>
                <div>
                    <div fxLayout="row" fxLayoutGap="20px" class="mt-14">
                        <div fxFlex="50" class="service-provide-info">
                            <p class="service-provide-header">
                                {{ "SERVICE_PROVIDER.STREET" | translate }}
                            </p>
                            <p class="service-provide-des">
                                {{ providerInfo?.street || "" }}
                            </p>
                        </div>
                        <div fxFlex="50" class="service-provide-info">
                            <p class="service-provide-header">
                                {{ "SERVICE_PROVIDER.STREET_NUMBER" | translate }}
                            </p>
                            <p class="service-provide-des">
                                {{ providerInfo?.streetNo || "" }}
                            </p>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutGap="20px" class="mt-14">
                        <div fxFlex="50" class="service-provide-info">
                            <p class="service-provide-header">
                                {{ "SERVICE_PROVIDER.ZIP_CODE" | translate }}
                            </p>
                            <p class="service-provide-des">
                                {{ providerInfo?.zip || "" }}
                            </p>
                        </div>
                        <div fxFlex="50" class="service-provide-info">
                            <p class="service-provide-header">{{ "SERVICE_PROVIDER.CITY" | translate }}</p>
                            <p class="service-provide-des">
                                {{ providerInfo?.city || "" }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="table-separator"></div>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" class="mt-14">
                    <div class="service-provide-info">
                        <p class="service-provide-header">
                            {{ "SERVICE_PROVIDER.CONTACT_NAME" | translate }}
                        </p>

                        <div>
                            <p class="service-provide-des">
                                {{ providerInfo?.contactName || "" }}
                            </p>
                        </div>
                    </div>
                    <div class="service-provide-info">
                        <p class="service-provide-header">{{ "SERVICE_PROVIDER.EMAIL" | translate }}</p>
                        <div>
                            <p class="service-provide-des">
                                {{ providerInfo?.email || "" }}
                            </p>
                        </div>
                    </div>
                    <div class="service-provide-info">
                        <p class="service-provide-header">{{ "SERVICE_PROVIDER.PHONE" | translate }}</p>
                        <div>
                            <p class="service-provide-des">
                                {{ providerInfo?.phone || "" }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div fxFlex="40">
        <div fxLayout="column">
            <div class="service-provider-details-container mt-8" style="height: 169px; overflow-x: auto">
                <p class="service-provider-nav">{{ "SERVICE_PROVIDER.CASES" | translate }} ({{providerInfo?.auditCasesCount}})</p> 
                <div class="mt-8" *ngFor="let case of providerInfo?.auditCases">
                    <p class="cases-link">
                        <a href="{{ case }}" target="_blank">{{ case }}</a>
                    </p>
                </div>
            </div>
            <div class="service-provider-details-container" style="height: 169px; overflow-x: auto; margin-top: 17px">
                <p class="service-provider-nav">{{ "SERVICE_PROVIDER.CLAIMS" | translate }} ({{providerInfo?.repairCasesCount}})</p> 
                <div class="mt-8" *ngFor="let case of providerInfo?.repairCases">
                    <p class="cases-link">
                        <a href="{{ case }}" target="_blank">{{ case }}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
